<template>
  <div>
    <!-- Loading -->
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <BannerCarousel v-if="banner && banner.desktop_images.length > 0" :slides="banner" />
    <v-container id="events-list">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-layout justify-space-between class="pb-4" :column="$vuetify.breakpoint.xs">
        <v-flex shrink>
          <div class="d-flex flex-1 align-end">
            <span class="text-uppercase header bold text-tcdc-green">program</span>
          </div>
        </v-flex>
        <v-flex shrink :class="{'my-3':$vuetify.breakpoint.xs}">
          <div
            class="d-flex align-center" style="position: relative"
            :class="{ 'justify-end': $vuetify.breakpoint.mdAndUp }"
          >
            <GreenButton :label="$t('event.ourService')" @click.native="$router.push('/our-service')" />
            <v-tooltip bottom color="rgba(0,0,0,0)" v-if="$vuetify.breakpoint.smAndUp">
              <template v-slot:activator="{ on }">
                <img
                  v-on="on"
                  class="sort-icon pl-4 pb-1 cursor-pointer"
                  src="../../assets/icons/sorts/design-world.png"
                  @click="designCalendarHandler"
                />
              </template>
              <span class="text-tcdc-green bold sub-header1 text-uppercase">design world calendar</span>
            </v-tooltip>
            <div
                    v-else
                    class="text-tcdc-green text-uppercase d-flex align-center"
            >
                <img
                        class="sort-icon-mobile pl-4 mr-2 cursor-pointer"
                        src="../../assets/icons/sorts/design-world.png"
                        @click="designCalendarHandler"
                />
                <span style="font-size: 14px; font-weight: bold">design world calendar</span>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout justify-center mb-3>
        <v-flex :shrink="$vuetify.breakpoint.smAndUp">
          <div
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="d-flex flex-1 align-center"
                  style="position: relative;"
                  :class="{ 'justify-center': $vuetify.breakpoint.mdAndUp }"
          >
            <span class="text-uppercase text-tcdc-green bold pr-2">{{$t('event.sortBy')+':'}}</span>
            <template v-for="item of sortByList">
              <div :key="item.id.toString()" class="d-relative">
                <v-tooltip bottom color="rgba(0,0,0,0)">
                  <template v-slot:activator="{ on }">
                    <img
                            v-on="on"
                            class="tcdc-sort-icon-hover sort-icon px-2 cursor-pointer"
                            :src="eventSortType === item.name ? item.image_active:item.image_inactive"
                            @click="sortClick(item)"
                    />
                    <!--                    :src="events[0].event_type === item.name ? item.image_active:item.image_inactive"-->
                  </template>
                  <span class="text-tcdc-green bold sub-header1 text-uppercase">{{item.name}}</span>
                </v-tooltip>
              </div>
            </template>
          </div>
          <v-select
                  class="tcdc-sort-by-dropdown text-uppercase"
                  style="color: white;"
                  v-else
                  solo
                  rounded
                  color="white"
                  item-color="#2e8037"
                  background-color="#2e8037"
                  :items="sortByList"
                  item-text="name"
                  item-value="name"
                  :label="$t('event.sortBy')+':'"
                  v-model="eventSortType"
                  hide-details
                  @change="sortChange"
          ></v-select>
        </v-flex>
      </v-layout>
      <div v-if="eventSortType === 'date'">
        <div class="d-flex flex-1 py-2 borderbot">
          <div class="d-flex">
              <v-icon large color="#808080" class="mr-4">mdi-magnify</v-icon>
          </div>
          <div class="d-flex flex-1 align-center">
              <DatePicker
                      @onPress="yearMonthHandler"
                      :value="selectedDate"
                      class="cursor-pointer"
              />
          </div>
          <div class="d-flex align-center">
              <span
                      class="sub-header1 bold text-tcdc-grey1 mr-4 cursor-pointer"
                      @click="prevYear1Handler"
              >{{prevYearOne}}</span>
              <span
                      class="sub-header1 bold text-tcdc-grey1 cursor-pointer"
                      @click="prevYear2Handler"
              >{{prevYearTwo}}</span>
          </div>
        </div>
      </div>
      <v-row class="d-flex flex-wrap" v-if="events && events.length > 0">
        <template v-for="(item, index) in findHighlight() ? move(events,events.findIndex((event => event.highlight)),4):events">
          <v-col cols="12" :md="findHighlight() ? (item.highlight ? 12 : 6):(index == 4 ? 12 : 6)" :key="index">
            <EventCard
              class="cursor-pointer"
              :name="item[`name_${lang}`]"
              :time_start="item.start_date"
              :time_end="item.end_date"
              :place="item[`place_${lang}`]"
              :img="item.img_cover && item.img_cover.mobile ? ($vuetify.breakpoint.smAndDown ? item.img_cover.mobile : item.img_cover.desktop) : item.img_cover"
              :id="index"
              @click.native="eventDetailHandler(item.id)"
            />
          </v-col>
        </template>
      </v-row>
        <v-row v-else class="grey--text mt-3 px-2">
            <v-col style="text-align: center">
                {{$t('event.itemNotFound')}} {{branchName}}
            </v-col>
        </v-row>
      <v-row class="pt-4 d-flex justify-end">
<!--        <v-col class="text-left">-->
<!--          <GreenButton label="previous" v-if="eventPage.current_page !== 1" @onPress="prevPage()" />-->
<!--        </v-col>-->
<!--        <v-col class="text-right">-->
<!--          <GreenButton label="next" v-if="eventPage.current_page !== eventPage.last_page" @onPress="nextPage()" />-->
<!--        </v-col>-->
          <v-pagination
                  v-if="eventPage"
                  v-model="eventPage.current_page"
                  :length="eventPage.last_page"
                  total-visible="7"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  color="#2e8037"
                  @input="(event) => {getEventData(event); $vuetify.goTo('#events-list');}"
          ></v-pagination>
      </v-row>
      <v-row class="pt-7 pb-3">
        <v-col>
          <span class="text-uppercase text-tcdc-green sub-header1 bold">{{$t('event.service')}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <ServiceExpandable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventCard from "../../components/cards/EventCard";
import GreenButton from "../../components/buttons/GreenButton";
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
// import GreenLabel from "../../components/labels/GreenLabel";
import BannerCarousel from "../../components/carousels/BannerCarousel";
import {mapState} from "vuex";
import _move from 'lodash-move';
import Loading from 'vue-loading-overlay';
import moment from "moment";
import DatePicker from "../../components/pickers/DatePicker";

export default {
  components: {
    EventCard,
    GreenButton,
    ServiceExpandable,
    // GreenLabel
    BannerCarousel,
    DatePicker,
    Loading
  },
    metaInfo: {
        meta: [
            { charset: 'utf-8' },
            {
                property: 'og:title',
                content: 'Test title',
                // following template options are identical
                // template: '%s - My page',
                // template: chunk => `${chunk} - My page`,
                vmid: 'og:title'
            }
        ]
    },
  async created() {
    this.isLoading = true;
    this.items[0].text = this.branchName;
    const date = new Date();
    const currentMonth = parseInt(date.getMonth()) + 1;
    const currentYear = date.getFullYear();
    this.prevYear1 = currentYear - 1;
    this.prevYear2 = currentYear - 2;
    this.selectedDate = `${currentYear} ${this.monthList[currentMonth]}`;

    this.date = `${currentYear}-${moment().month(this.monthList[currentMonth]).format('MM')}`;
    // this.$store.dispatch('Program/onGetDesignWorldCalendar', { date: param, lang: this.lang });
    await this.getEventData();
    this.isLoading = false;
  },
  computed:{
    ...mapState({
      events: state => {
        if (state.Program.programs) {
            // console.log('state',Object.values(state.Program.programs))
          return Object.values(state.Program.programs.data).map((event,index) => ({
            index: index,
            id: event.product_id,
            name_th: event.name_th,
            name_en: event.name_en,
            start_date: event.start_date,
            end_date: event.end_date,
            place_th: event.location_name_th,
            place_en: event.location_name_en,
            img_cover: event.img_cover_desktop && event.img_cover_mobile ? { mobile: event.img_cover_mobile, desktop: event.img_cover_desktop } : event.img_cover_desktop,
            highlight: event.is_highlight ? true : false,
          }));
        }
      },
      eventPage: state => state.Program.programs,
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      tagName: state => state.Branch.tag_name,
      lang: state => state.Branch.lang,
      banner: state => state.ServiceMenu.banner
    }),
    branchChanged: function() {
      return this.branchName;
    },
    prevYearOne: function () {
        if (this.lang === 'th') {
            return parseInt(this.prevYear1) + 543;
        } else {
            return this.prevYear1;
        }
    },
    prevYearTwo: function () {
        if (this.lang === 'th') {
            return parseInt(this.prevYear2) + 543;
        } else {
            return this.prevYear2;
        }
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
      this.getEventData();
    }
  },
  methods: {
    eventDetailHandler(id) {
      this.$store.dispatch("Program/getProgramEventById",{
        id: id,
        lang: this.lang,
      });
      this.$router.push(`/events/${id}`);
    },
    findHighlight() {
        let found = false;
        for (const e of this.events) {
            if (e.highlight) {
                found = true;
                break;
            }
        }
        if (found) {
            return true;
        }
        return false;
    },
    designCalendarHandler() {
      this.$router.push(`/service/resource-center/design-world-calendar`);
    },
    async getEventData(page) {
        page = page ? page : 1;
        this.isLoading = true;
        await this.$store.dispatch("Program/getProgramEventAll",{
             tag: this.tagName,
             lang: this.lang,
             page: page,
             sort: this.eventSortType,
             eventdate: this.date
        });
        this.isLoading = false;
        return true;
    },
    changePage(page) {
      this.$store.dispatch('Program/getProgramByPage', {
        tag: this.tagName,
        page: page,
        sort: this.eventSortType
      });
    },
    sortClick(type) {
      this.eventSortType = type.name;
      switch (type.name) {
        case 'exhibition':
        case 'workshop':
        case 'seminar':
          // this.searchBox = false;
          this.$store.dispatch('Program/getProgramEventAll', { tag: this.tagName, lang: this.lang, sort: type.name });
          break;

        case 'date':
            this.date = this.selectedDate.split(' ')[0] + '-' + moment().month(this.selectedDate.split(' ')[1]).format('MM');
            this.$store.dispatch('Program/getProgramEventAll', {
                tag: this.tagName,
                lang: this.lang,
                sort: 'date',
                eventdate: this.date
            });
            break;
      }
    },
    sortChange(type) {
        switch (type) {
            case 'exhibition':
            case 'workshop':
            case 'seminar':
                // this.searchBox = false;
                this.$store.dispatch('Program/getProgramEventAll', { tag: this.tagName, lang: this.lang, sort: type });
                break;

            case 'date':
                this.date = this.selectedDate.split(' ')[0] + '-' + moment().month(this.selectedDate.split(' ')[1]).format('MM');
                this.$store.dispatch('Program/getProgramEventAll', {
                    tag: this.tagName,
                    lang: this.lang,
                    sort: 'date',
                    eventdate: this.date
                });
                break;
        }
    },
    yearMonthHandler(yearMonth) {
        const arr = yearMonth.split("-");
        const year = parseInt(arr[0]);
        const month = parseInt(arr[1]);
        this.prevYear1 = year - 1;
        this.prevYear2 = year - 2;
        this.selectedDate = `${year} ${this.monthList[month]}`;
        this.date  = `${year}-${moment().month(this.monthList[month]).format('MM')}`;
        this.$store.dispatch('Program/getProgramEventAll', {
            tag: this.tagName,
            lang: this.lang,
            sort: 'date',
            eventdate: this.date
        });
    },
    prevYear1Handler() {
        const arr = this.selectedDate.split(" ");
        const year = parseInt(this.prevYear1);
        const month = arr[1];
        this.prevYear1 = year - 1;
        this.prevYear2 = year - 2;
        this.selectedDate = `${year} ${month}`;
        this.date = `${year}-${moment().month(month).format('MM')}`;
        this.$store.dispatch('Program/getProgramEventAll', {
            tag: this.tagName,
            lang: this.lang,
            sort: 'date',
            eventdate: this.date
        });
    },
    prevYear2Handler() {
        const arr = this.selectedDate.split(" ");
        const year = parseInt(this.prevYear2);
        const month = arr[1];
        this.prevYear1 = year - 1;
        this.prevYear2 = year - 2;
        this.selectedDate = `${year} ${month}`;
        this.date  = `${year}-${moment().month(month).format('MM')}`;
        this.$store.dispatch('Program/getProgramEventAll', {
            tag: this.tagName,
            lang: this.lang,
            sort: 'date',
            eventdate: this.date
        });
    }
  },
  data: () => ({
    eventSortType: 'date',
    isLoading: false,
    move: _move,
    selectedDate: "",
    prevYear1: "",
    prevYear2: "",
    sortByList: [
      {
        id: 1,
        name: "date",
        image_active: require("../../assets/icons/sorts/calendar.png"),
        image_inactive: require("../../assets/icons/sorts/calendar-inactive.png")
      },
      {
        id: 2,
        name: "exhibition",
        image_active: require("../../assets/icons/sorts/exhibition.png"),
        image_inactive: require("../../assets/icons/sorts/exhibition-inactive.png")
      },
      {
        id: 3,
        name: "workshop",
        image_active: require("../../assets/icons/sorts/workshop.png"),
        image_inactive: require("../../assets/icons/sorts/workshop-inactive.png")
      },
      {
        id: 4,
        name: "seminar",
        image_active: require("../../assets/icons/sorts/seminar.png"),
        image_inactive: require("../../assets/icons/sorts/seminar-inactive.png")
      }
    ],
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "PROGRAM",
        to: "/home"
      }
    ],
    serviceList: [
      {
        id: "1",
        title: "membership",
        layout: "1"
      },
      {
        id: "2",
        title: "resource center",
        layout: "2"
      },
      {
        id: "3",
        title: "consult",
        layout: "3"
      },
      {
        id: "4",
        title: "venue hire",
        layout: "4"
      },
      {
        id: "5",
        title: "visit & service area",
        layout: "5"
      }
    ],
      date: '',
    monthList: [
        "",
        "JANUARY",
        "FEBUARY",
        "MARCH",
        "APRIL",
        "MAY",
        "JUNE",
        "JULY",
        "AUGUST",
        "SEPTEMBER",
        "OCTOBER",
        "NOVEMBER",
        "DECEMBER"
    ]
  })
};
</script>

<style lang="scss">
.sort-icon {
  height: 40px;
  object-fit: contain;
}
.sort-icon-mobile {
  height: 32px;
  object-fit: contain;
}
.search-icon {
  height: 40px;
  width: 40px;
  object-fit: contain;
}
.search-box {
  border: solid 2px $tcdcGreen;
  background: #fff;
  min-width: 280px;
}
.borderbot {
    border-bottom: 2px solid $tcdcGrey1;
}
/* .tcdc-sort-icon-hover:hover + .tcdc-sort-tooltip {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
} */
/* .tcdc-sort-tooltip {
  display: none;
} */
</style>
